module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOBAMAAAC88gOBAAAAAXNSR0IArs4c6QAAABJQTFRF+PjIgHhwuLjQ2NjA+Pj4////OOycSwAAAAF0Uk5TAEDm2GYAAABhSURBVBjTZc7hCYBACIZhowX6xAU0B4ia4AP3nym464Kr958PiMp6TR1yxtQu8UkikllWrDLtQAMNIF5wZWow8gFjMEuLA9yUCSUGMH8rymxXin0FAUevwecxnWeXBVPbDXKCHvQz0gvqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/types/Steel.png
// module id = 173
// module chunks = 0